import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import ControlGroup from './control_group';

class SelectInput extends React.Component {

  constructor (props) {
    super(props);
    this.displayName = 'Input';
  }

  static option (option) {
    return <option key={option.value || option} value={option.value || option} >{option.name || option}</option>;
  }

  group (group, options) {
    return (
      <optgroup key={group} label={group}>
        {options.map(option => SelectInput.option(option))}
      </optgroup>
    );
  }

  options () {
    if (this.props.children) {
      return this.props.children;
    } else if (this.props.groups && this.props.options) {
      return this.props.groups.map(group => this.group(group, _.filter(this.props.options, { group })));
    } else if (this.props.options) {
      return this.props.options.map(SelectInput.option.bind(this));
    }
    return <option value="" />;
  }

  render () {
    return (
      <ControlGroup className={this.props.className} style={this.props.style} label={this.props.label} helpBlockText={this.props.helpBlockText}>
        <select
          className={cx(this.props.selectClass, (this.props.disabled ? 'disabled' : null))}
          id={this.props.id}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          name={this.props.name}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder} >

          {this.options()}

        </select>
      </ControlGroup>
    );
  }
}

module.exports = SelectInput;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/select_input.jsx